import { MULTICINEMA, SINGLECINEMA } from "../constants/cinemaTypes"

const getCinemaType = cinemas => {
    if(Object.keys(cinemas).length > 1) {
        return MULTICINEMA
    } else {
        return SINGLECINEMA
    }
}

export default getCinemaType